import React from "react";
import "./About.css";
import AboutMe from "../../assets/me2.jpeg";
import { MdOutlineWorkOutline } from "react-icons/md";
import { VscFolderLibrary } from "react-icons/vsc";
import { HiOutlineLightBulb } from "react-icons/hi";

function About() {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me__img">
            <img src={AboutMe} alt="about image" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <MdOutlineWorkOutline className="about__icon" />
              <h5>Experience</h5>
              <small>3+ years</small>
            </article>

            <article className="about__card">
              <HiOutlineLightBulb className="about__icon" />
              <h5>Skills</h5>
              <small>Frontend & Backend</small>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed Projects</small>
            </article>
          </div>

          <p>
            As a software engineer and fullstack developer, I have a passion for
            creating innovative solutions to complex problems. I have a
            comprehensive understanding of the web development process. I strive
            to build applications that are not only functional, but also
            aesthetically pleasing and user-friendly. With a dedication to
            staying up-to-date with the latest technologies and programming
            languages, I am committed to delivering high-quality code and
            ensuring a seamless user experience.
          </p>

          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
}

export default About;
